import React from 'react';
import { useQuery } from '@apollo/client';
import { Box, Select, InputLabel, MenuItem, FormControl } from '@material-ui/core';
import { GET_BRANDS } from '../../queries/products/brand';
import { GET_PRODUCTS_BY_BRAND } from '../../queries/products/product';

const GetBrands = () => useQuery(GET_BRANDS, { fetchPolicy: 'network-only' });
const GetProducts = (brandId) => useQuery(GET_PRODUCTS_BY_BRAND, { variables: { brandId: brandId || null }, fetchPolicy: 'network-only' });

export const SelectBrandProduct = ({ brandId, setBrandId, productId, setProductId }) => {
  const queryBrands = GetBrands();
  const queryProducts = GetProducts(brandId);

  const handleChange = (e, set) => {
    set(e.target.value);
  };

  return (
    <Box display="flex">
      <Box ml={2} mr={2}>
        <FormControl style={{ minWidth: 120 }}>
          <InputLabel id="select-brand-block-label">Brand</InputLabel>
          <Select
            labelId="select-brand-block-label"
            id="select-brand-block"
            value={brandId}
            onChange={(e) => handleChange(e, setBrandId)}
          >
            {queryBrands.data && queryBrands.data.listBrands ? queryBrands.data.listBrands.map((user) => <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>) : null}
          </Select>
        </FormControl>
      </Box>
      <Box>
        <FormControl style={{ minWidth: 120 }}>
          <InputLabel id="select-product-block-label">Product</InputLabel>
          <Select
            labelId="select-product-block-label"
            id="select-product-block"
            value={productId}
            onChange={(e) => handleChange(e, setProductId)}
          >
            {queryProducts.data && queryProducts.data.listProductsByBrand ? queryProducts.data.listProductsByBrand.map((user) => <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>) : null}

          </Select>
        </FormControl>
      </Box>

    </Box>
  );
};
